<template>
    <div v-if="orderItemEmpty">
        <q-inner-loading :showing="orderItemEmpty">
            <q-spinner-pie color="primary" size="40px" />
        </q-inner-loading>
    </div>
    <div v-else class="order-item row">
        <!-- course image -->
        <div
            class="course-img"
            :style="`background-image: url(${getImage(
                orderItem.courses.coursepicture_id
            )})`"
        >
            <div class="overlay" :class="overlayColor(index)"></div>
        </div>
        <!-- course info: type, title and duration -->
        <div class="course-info col-12 col-sm-grow col-md-4 col-lg-6">
            <div class="course-type row items-center">
                <template
                    v-if="
                        orderItem.courses.courses_coursetype.slug ===
                        slugs.courseTypes.online
                    "
                >
                    <q-icon name="language" class="q-mr-sm"></q-icon>
                    {{ $t('general.online') }}
                </template>
                <template
                    v-if="
                        orderItem.courses.courses_coursetype.slug ===
                        slugs.courseTypes.onsite
                    "
                >
                    <q-icon name="business" class="q-mr-sm"></q-icon>
                    {{ $t('general.presential') }}
                </template>
            </div>
            <h5>
                {{ JSONParseTranslations(orderItem.courses.title, locale.key) }}
            </h5>
            <p>
                {{ $t('courses.hours', { hours: orderItem.courses.duration }) }}
            </p>
        </div>

        <!-- prices and units -->
        <div class="course-price col-12 col-sm-12 col-md text-right">
            <div class="row justify-end q-mt-sm">
                <div class="course-quantity col-auto">
                    <span class="q-mx-md q-my-sm">{{
                        orderItem.quantity
                    }}</span>
                    <span>UN</span>

                    <div class="text-caption">
                        <span class="text-uppercase"
                            >{{ $t('cart.unit_price_abbreviation') }} ({{
                                $t('general.without_vat')
                            }})</span
                        >:
                        <!-- normal price -->
                        <span
                            :class="[
                                { 'text-strike': orderItem.promotion_discount },
                                { 'text-body1': !orderItem.promotion_discount },
                            ]"
                            >{{
                                new Intl.NumberFormat(
                                    currency.definition['locale'],
                                    {
                                        style: 'currency',
                                        currency: currency.key,
                                    }
                                ).format(
                                    parseFloat(
                                        JSON.parse(orderItem.unit_price)[
                                            currency.key
                                        ]
                                    )
                                )
                            }}</span
                        >
                    </div>
                </div>
                <div class="price">
                    <span>
                        ({{ orderItem.tax }}{{ $t('general.vat_percentage') }})
                    </span>
                    {{
                        new Intl.NumberFormat(currency.definition['locale'], {
                            style: 'currency',
                            currency: currency.key,
                        }).format(
                            JSON.parse(orderItem.item_total)[currency.key]
                        )
                    }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import store from '@/store'
import { slugs } from '@/local-shared/mixins/slugs'
import env from '@/.env.js'
import _ from 'lodash'

export default {
    name: 'OrderItemComponent',

    mixins: [translate],

    props: {
        index: {
            type: Number,
            default: 0,
        },

        orderItem: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            quantity: this.orderItem.quantity,

            slugs: slugs,
        }
    },

    computed: {
        orderItemEmpty() {
            return _.isEmpty(this.orderItem)
        },

        locale() {
            return store.getters['locale/currentLocale']
        },

        currency() {
            return store.getters['currency/currentCurrency']
        },
    },

    methods: {
        overlayColor(index) {
            return 'overlay-color-' + (index % 3)
        },

        getImage(pictureId) {
            return `${env.endpoint_backend}/pictures/${pictureId}`
        },
    },
}
</script>
